import { isAcceptInteractor } from "../partialAcceptance";
import { Interactor } from "./missionMap/missionMap";

/**
 * Reply buttons, always in the same order: decline, hold, accept.
 *
 * Mercury hands them over in whatever order the pipeline was drawn in, and the
 * two places play renders them disagreed — the season card sorted by Position
 * then ID, the call page's response block by ID alone — so the same three
 * replies came out "Accept, Decline, Hold" in one place and could come out
 * differently in another. A musician answering several calls should find the
 * same button in the same place every time; the affirmative one especially
 * should never move under a thumb.
 *
 * Accept last, hold before it, everything else first in whatever order it
 * already had. Deliberately NOT keyed on a "decline" name: decline is the
 * residual reply everywhere else in this app (see swipeReplies), and a pipeline
 * with an extra custom button would otherwise need a name pattern per org.
 *
 * The sort is stable, so interactors of equal rank keep the order they came in
 * with — pass an already-ordered list and that ordering survives inside each
 * rank.
 */
const RANK_OTHER = 0;
const RANK_HOLD = 1;
const RANK_ACCEPT = 2;

function replyRank(interactor: Interactor): number {
  if (isAcceptInteractor(interactor)) return RANK_ACCEPT;
  if (/hold/i.test(interactor.Name ?? "")) return RANK_HOLD;

  return RANK_OTHER;
}

/**
 * @param {Interactor[]} interactors reply buttons, in any order
 * @returns {Interactor[]} a new array ordered decline → hold → accept
 */
export function inReplyOrder(interactors: Interactor[]): Interactor[] {
  return [...interactors].sort((a, b) => replyRank(a) - replyRank(b));
}
